import { Container, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { Fade } from '../Fade';
import EditorContext from './EditorContext';

const EditorContainer = ({ children }: { children: React.ReactNode }) => {
  const { letterId } = useContextSelector(EditorContext, (ctx) => ctx.sideCar);
  const sideCarOpen = letterId !== undefined;

  const bpPadding = useBreakpointValue({ base: 4, xs: 8, lg: 16 });
  const padding = sideCarOpen ? 8 : bpPadding;
  const maxWidth = sideCarOpen ? '1750px' : 'container.lg';

  return (
    <Fade>
      <Container padding={padding} pt={0} maxWidth={maxWidth}>
        {children}
      </Container>
    </Fade>
  );
};

export default EditorContainer;
